var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	frontCarousel: false,
	init: function() {
		site.stickyHead.init();
		site.frontpage.hasScrolled();
		site.frontpage.initFrontpageCarousel();

		$(window).resize(function() {
			site.frontpage.initFrontpageCarousel();
		});

		site.owl.init('#logos > ul', {
			loop:true,
			nav:true,
			margin:10,
			autoplay: false,
			autoplayTimeout: 6000,
			responsive: {
				0: {items:1},
				500: {items:2},
				992: {items:4},
				1400: {items:6}
			},
			navText: [
				"<i class='fa fa-arrow-left'></i>",
				"<i class='fa fa-arrow-right'></i>"
			]
		});
	},

	initFrontpageCarousel: function() {
		var $currentWidth = $(window).width();
		if ($currentWidth < 768) {
			if (!site.frontpage.frontCarousel) {
				site.owl.init('#ad_wrapper ul', {
					items: 1,
					nav: true,
					navText: ['', '']
				});
				site.frontCarousel = true;
			}
		} else {
			if (site.frontpage.frontCarousel) {
				site.frontpage.frontCarousel.owlCarousel('destroy').removeClass('owl-carousel owl-loaded');
				site.frontpage.frontCarousel = false;
			}
		}
	},

	hasScrolled: function() {
		window.addEventListener('scroll', function(e){
			var distanceY = window.pageYOffset || document.documentElement.scrollTop,
				$bannerHeight = $('.banner__image').innerHeight();
			if (distanceY > $bannerHeight) {
				$('body').addClass('hasScrolled');
			} else {
				$('body').removeClass('hasScrolled');
			}
		});
	},
};

site.addFileInExtrasUrl = {
	init: function () {
		$('button.addFile').click(function(e) {
			if (window.launchElFinder) {
				window.launchElFinder(this.extras_callback);
			}
			else if (!moya.editor.tiny.elfinder.opts) {
				alert('tinymce missing');
			}
			else {
				// This is for newer version of tiny
				const opts = moya.editor.tiny.elfinder.opts;
				opts.editorCallback = site.addFileInExtrasUrl.extras_callback;
				opts.lang = moya.lang;
				$('<div id="myelfinder" />').elfinder(opts);
			}
			e.preventDefault();
			return false;
		});
	},

	extras_callback: function (url) {
		var inputUrl =  document.querySelector('input[id="url"]');
		if (inputUrl) {
			inputUrl.value = url;
		}
	}
};

site.projectView = {
	init: function() {
		var $connectedContent = $('.connected__content p');
		var $connectedWrap = $('.connectedFiles');

		if($connectedContent.length >= 4 && screen.width >= 992) {
			$connectedWrap.addClass('seeMore');
		}

		$('.connectedFiles .btn-seeMore').on('click', function () {
			$connectedWrap.removeClass('seeMore');
		});
	}
};

site.extendEmployee = {
	init: function() {
		var $employee = $('#extras .starfsfolk .item .wrap');
		var $employeeInfo = $('#extras .starfsfolk .item .info');

		$employeeInfo.each(function() {
			var $height = $(this)[0].scrollHeight;
			$(this).css('max-height', $height);
		});

		$employee.on('click', function(e) {
			e.stopPropagation();
			var $this = $(this).parent();
			// Item is already open, so we close it
			if ($this.is('.emp-open')) {
				$this.removeClass('emp-open');
				return;
			}
			// Close all others
			$employee.parent().removeClass('emp-open');
			// Open this one
			$this.addClass('emp-open');
		});

		$('body').on('click', function () {
			if ($employee.parent().is('.emp-open')) {
				$employee.parent().removeClass('emp-open');
			}
		});

		window.addEventListener('resize', function(event){
			$employeeInfo.each(function() {
				var $height = $(this)[0].scrollHeight;
				$(this).css('max-height', $height);
			});
		});
	}
};

site.megamenuFix = {
	init: function () {
		$('#mainmenu li.level1.mega .megamenu').on('click', (e) => {
			if (e.target.classList.contains('wrap')) {
				document.body.classList.remove('mainmenu-open');
				document.querySelectorAll('#mainmenu .level1.children').forEach((el) => {
					el.classList.remove('open');
				})
			}
		})
	}
};


site.showMore = {
	init: function () {
		$(document).ready(function(){
				$("#meetings #seeMore").on('click', function(e) {
				e.preventDefault();
				$('body').removeClass('meetingsShowLess');
				document.getElementById("loaderMeetings").remove();
			});
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.megamenuFix.init();
	site.accessibility.init();
	site.extendEmployee.init();
	site.showMore.init();
	site.owl.init('.newsConnected .entries', {
		nav:true,
		margin:20,
		navText : ["<i class='fas fa-arrow-alt-circle-left'></i>","<i class='fas fa-arrow-alt-circle-right'></i>"],
		responsive:{
		0:{
			items:1
		},
		480:{
			items:1
		},
		900:{
			items:2
		}
	}
	});
	site.owl.init('.customCards.eventList', {
		nav:true,
		margin:20,
		navText : ["<i class='fas fa-arrow-alt-circle-left'></i>","<i class='fas fa-arrow-alt-circle-right'></i>"],
		responsive:{
			0:{
				items:1
			},
			480:{
				items:2
			},
			900:{
				items:4
			}
		}
	});

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.projectView')) {
		site.projectView.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});


